import { render, staticRenderFns } from "./category-details-catalogue.vue?vue&type=template&id=77f29b2b"
import script from "./category-details-catalogue.vue?vue&type=script&lang=js"
export * from "./category-details-catalogue.vue?vue&type=script&lang=js"
import style0 from "./category-details-catalogue.vue?vue&type=style&index=0&id=77f29b2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports